import React from "react";
import { useSelector } from "react-redux";

function HalfPageDesign(props) {
  const { gradientColor } = useSelector((state) => state.theme);
  const themeImage = window.sessionStorage.getItem("theme_landing_image");
  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div className="row">
        <div
          className="col-md-6 d-sm-none d-none d-md-block d-lg-block"
          style={{
            background: `linear-gradient(${gradientColor.toString()})`,
            minHeight: "100vh",
            overflow: "hidden",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
          }}
        >
          {themeImage && (
            <img
              src={themeImage}
              alt="Theme"
              className="w-100"
            />
          )}
        </div>
        <div
          className="col-md-6 p-5"
          style={{
            height: "100vh",
            overflow: "auto",
          }}
        >
          {props.innerDesign}
        </div>
      </div>
    </div>
  );
}
export default HalfPageDesign;
